import { render, staticRenderFns } from "./PerformanceBox.vue?vue&type=template&id=f2d5b542&scoped=true&"
import script from "./PerformanceBox.vue?vue&type=script&lang=js&"
export * from "./PerformanceBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d5b542",
  null
  
)

export default component.exports